import { ImportantMessageType } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { isBrowser } from '../../utils/environment';
import {
    ImportantMessageIcon,
    StyledImportantMessage,
    StyledImportantMessageCloseButton,
    StyledImportantMessageCloseIcon,
    StyledImportantMessageContainer,
    StyledImportantMessageLink,
    StyledImportantMessageText,
    StyledImportantMessageTextContainer,
    StyledImportantMessageVisuallyHidden,
} from './ImportantMessage.styles';

export const IMPORTANT_MESSAGE_TYPES = Object.keys(ImportantMessageType).map((key) => ({
    [key]: ImportantMessageType[key],
}));

type ImportantMessageProps = {
    type: ImportantMessageType;
    combinedId: string;
    text: string;
    link?: string;
    linkText?: string;
    isRead: boolean;
    onClose: (combinedId: string) => void;
};

const ImportantMessage = ({
    type,
    combinedId,
    text,
    link,
    linkText,
    isRead,
    onClose,
}: ImportantMessageProps) => {
    if (!isBrowser() || isRead) {
        return null;
    }

    return (
        <StyledImportantMessageContainer messageType={type} data-testid={`important-message-${type}`}>
            <StyledImportantMessage>
                <ImportantMessageIcon aria-hidden="true" iconType={type} />
                <StyledImportantMessageTextContainer>
                    <StyledImportantMessageText data-rt="important-message">
                        {text}{' '}
                        {link && (
                            <StyledImportantMessageLink href={link}>
                                {linkText || 'Läs mer'}
                            </StyledImportantMessageLink>
                        )}
                    </StyledImportantMessageText>
                </StyledImportantMessageTextContainer>
                {combinedId && (
                    <StyledImportantMessageCloseButton
                        type="button"
                        data-testid="close-important-message"
                        data-rt="close-important-message"
                        onClick={() => onClose(combinedId)}
                    >
                        <StyledImportantMessageCloseIcon aria-hidden="true" />
                        <StyledImportantMessageVisuallyHidden>
                            Stäng meddelande
                        </StyledImportantMessageVisuallyHidden>
                    </StyledImportantMessageCloseButton>
                )}
            </StyledImportantMessage>
        </StyledImportantMessageContainer>
    );
};

export default ImportantMessage;
